import React, { useState } from 'react';
import RejectionReasonSelector from './RejectionReasonSelector';
import { validateChargebackEnhanced, rejectChargeback } from '../config/api';

const ChargebackActions = ({ chargeback, onStatusChange, currentUser }) => {
  const [isRejecting, setIsRejecting] = useState(false);
  const [selectedReason, setSelectedReason] = useState('');
  const [rejectionDetails, setRejectionDetails] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleValidate = async () => {
    setIsLoading(true);
    try {
      const result = await validateChargebackEnhanced(chargeback.id);
      if (result.success && result.data) {
        onStatusChange(result.data);
      }
    } catch (error) {
      console.error('Error validating chargeback:', error);
      alert('Error validating chargeback. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleReject = async () => {
    if (!selectedReason) {
      alert('Please select a rejection reason');
      return;
    }

    setIsLoading(true);
    try {
      const result = await rejectChargeback({
        chargebackId: chargeback.id,
        rejectionReasonId: selectedReason,
        rejectedBy: currentUser.id,
        rejectionDetails: {
          additionalNotes: rejectionDetails,
          rejectedAt: new Date().toISOString()
        }
      });
      
      if (result.success && result.data) {
        onStatusChange(result.data);
        setIsRejecting(false);
        setSelectedReason('');
        setRejectionDetails('');
      }
    } catch (error) {
      console.error('Error rejecting chargeback:', error);
      alert('Error rejecting chargeback. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="chargeback-actions">
      <div className="action-buttons">
        <button
          onClick={handleValidate}
          className="btn btn-primary"
          disabled={chargeback.status === 'VALIDATED' || isLoading}
          title="Validate chargeback"
        >
          {isLoading ? 'Processing...' : 'Validate'}
        </button>
        
        <button
          onClick={() => setIsRejecting(!isRejecting)}
          className="btn btn-danger"
          disabled={chargeback.status === 'REJECTED' || isLoading}
          title="Reject chargeback"
        >
          Reject
        </button>
      </div>

      {isRejecting && (
        <div className="rejection-form">
          <RejectionReasonSelector 
            onReasonSelect={setSelectedReason}
            selectedReason={selectedReason}
          />
          <div className="form-group">
            <label htmlFor="rejection-details">Additional Details:</label>
            <textarea
              id="rejection-details"
              value={rejectionDetails}
              onChange={(e) => setRejectionDetails(e.target.value)}
              placeholder="Add any additional notes about this rejection..."
              rows="3"
            />
          </div>
          <div className="form-actions">
            <button onClick={handleReject} className="btn btn-danger" disabled={isLoading} title="Confirm rejection">
              {isLoading ? 'Processing...' : 'Confirm Rejection'}
            </button>
            <button onClick={() => setIsRejecting(false)} className="btn btn-secondary" title="Cancel">
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChargebackActions;
